import React from 'react'

import Accordion from '@components/Content/Accordion/Accordion'
import Section from '@components/Section/Section'
import SectionContent from '@components/Section/SectionContent'
import SectionTitle from '@components/Section/SectionTitle'

import { AccordionItemType } from '@contracts/Components/Accordion'
import { FAQsType } from '@contracts/Components/FAQs'
import { StyledTitleType } from '@contracts/Components/StyledTitle'

import * as styles from './FAQSection.module.scss'

interface Props {
	data: FAQsType
}

const FAQSection = (props: Props) => {
	const items: AccordionItemType[] = props.data.map((item) => {
		return {
			title: item.faq.title,
			content: item.faq.content,
		}
	})

	const sectionTitle: StyledTitleType = [
		{
			styledText: {
				text: 'FAQs',
				isYellow: false,
				isThin: false,
				isSplit: false,
			},
		},
	]

	return (
		<Section className={styles.section} paddingSmall>
			<SectionTitle title={sectionTitle} />

			<SectionContent className={styles.content}>
				<Accordion items={items} />
			</SectionContent>
		</Section>
	)
}

export default FAQSection
